import { render, staticRenderFns } from "./SpecialZoneDeliveryRate.vue?vue&type=template&id=d136a668"
import script from "./SpecialZoneDeliveryRate.vue?vue&type=script&lang=js"
export * from "./SpecialZoneDeliveryRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports